var map = {
	"./ad.svg": 1012,
	"./ae.svg": 1013,
	"./af.svg": 1014,
	"./ag.svg": 1015,
	"./ai.svg": 1016,
	"./al.svg": 1017,
	"./am.svg": 1018,
	"./ao.svg": 1019,
	"./ar.svg": 1020,
	"./as.svg": 1021,
	"./at.svg": 1022,
	"./au.svg": 1023,
	"./aw.svg": 1024,
	"./az.svg": 1025,
	"./ba.svg": 1026,
	"./bb.svg": 1027,
	"./bd.svg": 1028,
	"./be.svg": 1029,
	"./bf.svg": 1030,
	"./bg.svg": 1031,
	"./bh.svg": 1032,
	"./bi.svg": 1033,
	"./bj.svg": 1034,
	"./bm.svg": 1035,
	"./bo.svg": 1036,
	"./br.svg": 1037,
	"./bs.svg": 1038,
	"./bt.svg": 1039,
	"./bw.svg": 1040,
	"./by.svg": 1041,
	"./bz.svg": 1042,
	"./ca.svg": 1043,
	"./cd.svg": 1044,
	"./cf.svg": 1045,
	"./cg.svg": 1046,
	"./ch.svg": 1047,
	"./ci.svg": 1048,
	"./ck.svg": 1049,
	"./cl.svg": 1050,
	"./cm.svg": 1051,
	"./cn.svg": 1052,
	"./co.svg": 1053,
	"./cr.svg": 1054,
	"./cu.svg": 1055,
	"./cv.svg": 1056,
	"./cw.svg": 1057,
	"./cy.svg": 1058,
	"./cz.svg": 1059,
	"./de.svg": 1060,
	"./dj.svg": 1061,
	"./dk.svg": 1062,
	"./dm.svg": 1063,
	"./do.svg": 1064,
	"./dz.svg": 1065,
	"./ec.svg": 1066,
	"./ee.svg": 1067,
	"./eg.svg": 1068,
	"./er.svg": 1069,
	"./es.svg": 1070,
	"./et.svg": 1071,
	"./fi.svg": 1072,
	"./fj.svg": 1073,
	"./fk.svg": 1074,
	"./fm.svg": 1075,
	"./fo.svg": 1076,
	"./fr.svg": 1077,
	"./ga.svg": 1078,
	"./gb.svg": 1079,
	"./gd.svg": 1080,
	"./ge.svg": 1081,
	"./gg.svg": 1082,
	"./gh.svg": 1083,
	"./gi.svg": 1084,
	"./gl.svg": 1085,
	"./gm.svg": 1086,
	"./gn.svg": 1087,
	"./gq.svg": 1088,
	"./gr.svg": 1089,
	"./gt.svg": 1090,
	"./gu.svg": 1091,
	"./gw.svg": 1092,
	"./hk.svg": 1093,
	"./hn.svg": 1094,
	"./hr.svg": 1095,
	"./ht.svg": 1096,
	"./hu.svg": 1097,
	"./id.svg": 1098,
	"./ie.svg": 1099,
	"./il.svg": 1100,
	"./im.svg": 1101,
	"./in.svg": 1102,
	"./io.svg": 1103,
	"./iq.svg": 1104,
	"./ir.svg": 1105,
	"./is.svg": 1106,
	"./it.svg": 1107,
	"./je.svg": 1108,
	"./jm.svg": 1109,
	"./jo.svg": 1110,
	"./jp.svg": 1111,
	"./ke.svg": 1112,
	"./kg.svg": 1113,
	"./kh.svg": 1114,
	"./ki.svg": 1115,
	"./km.svg": 1116,
	"./kn.svg": 1117,
	"./kp.svg": 1118,
	"./kr.svg": 1119,
	"./kw.svg": 1120,
	"./ky.svg": 1121,
	"./kz.svg": 1122,
	"./la.svg": 1123,
	"./lb.svg": 1124,
	"./li.svg": 1125,
	"./lk.svg": 1126,
	"./lr.svg": 1127,
	"./ls.svg": 1128,
	"./lt.svg": 1129,
	"./lu.svg": 1130,
	"./lv.svg": 1131,
	"./ly.svg": 1132,
	"./ma.svg": 1133,
	"./mc.svg": 1134,
	"./md.svg": 1135,
	"./me.svg": 1136,
	"./mg.svg": 1137,
	"./mh.svg": 1138,
	"./mk.svg": 1139,
	"./ml.svg": 1140,
	"./mm.svg": 1141,
	"./mn.svg": 1142,
	"./mo.svg": 1143,
	"./mp.svg": 1144,
	"./mq.svg": 1145,
	"./mr.svg": 1146,
	"./ms.svg": 1147,
	"./mt.svg": 1148,
	"./mu.svg": 1149,
	"./mv.svg": 1150,
	"./mw.svg": 1151,
	"./mx.svg": 1152,
	"./my.svg": 1153,
	"./mz.svg": 1154,
	"./na.svg": 1155,
	"./nato.svg": 1156,
	"./ne.svg": 1157,
	"./nf.svg": 1158,
	"./ng.svg": 1159,
	"./ni.svg": 1160,
	"./nl.svg": 1161,
	"./no.svg": 1162,
	"./np.svg": 1163,
	"./nr.svg": 1164,
	"./nu.svg": 1165,
	"./nz.svg": 1166,
	"./om.svg": 1167,
	"./pa.svg": 1168,
	"./pe.svg": 1169,
	"./pf.svg": 1170,
	"./pg.svg": 1171,
	"./ph.svg": 1172,
	"./pk.svg": 1173,
	"./pl.svg": 1174,
	"./pn.svg": 1175,
	"./pr.svg": 1176,
	"./ps.svg": 1177,
	"./pt.svg": 1178,
	"./pw.svg": 1179,
	"./py.svg": 1180,
	"./qa.svg": 1181,
	"./ro.svg": 1182,
	"./rs.svg": 1183,
	"./ru.svg": 1184,
	"./rw.svg": 1185,
	"./sa.svg": 1186,
	"./sb.svg": 1187,
	"./sc.svg": 1188,
	"./sd.svg": 1189,
	"./se.svg": 1190,
	"./sg.svg": 1191,
	"./si.svg": 1192,
	"./sk.svg": 1193,
	"./sl.svg": 1194,
	"./sm.svg": 1195,
	"./sn.svg": 1196,
	"./so.svg": 1197,
	"./sr.svg": 1198,
	"./ss.svg": 1199,
	"./st.svg": 1200,
	"./sv.svg": 1201,
	"./sx.svg": 1202,
	"./sy.svg": 1203,
	"./sz.svg": 1204,
	"./tc.svg": 1205,
	"./td.svg": 1206,
	"./tg.svg": 1207,
	"./th.svg": 1208,
	"./tibet.svg": 1209,
	"./tj.svg": 1210,
	"./tk.svg": 1211,
	"./tm.svg": 1212,
	"./tn.svg": 1213,
	"./to.svg": 1214,
	"./tr.svg": 1215,
	"./tt.svg": 1216,
	"./tv.svg": 1217,
	"./tw.svg": 1218,
	"./tz.svg": 1219,
	"./ua.svg": 1220,
	"./ug.svg": 1221,
	"./us.svg": 1222,
	"./uy.svg": 1223,
	"./uz.svg": 1224,
	"./ve.svg": 1225,
	"./vi.svg": 1226,
	"./vn.svg": 1227,
	"./vu.svg": 1228,
	"./ws.svg": 1229,
	"./ye.svg": 1230,
	"./za.svg": 1231,
	"./zm.svg": 1232,
	"./zw.svg": 1233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;